import { render, staticRenderFns } from "./AssignAuth.vue?vue&type=template&id=1b705389&scoped=true&"
import script from "./AssignAuth.vue?vue&type=script&lang=js&"
export * from "./AssignAuth.vue?vue&type=script&lang=js&"
import style0 from "./AssignAuth.vue?vue&type=style&index=0&id=1b705389&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b705389",
  null
  
)

export default component.exports